import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SinTransmitir } from './../../../../_entities/consola/sin-transmitir';
import { SinTransmitirService } from './../../services/sin-transmitir.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ALERTAS } from './../../../../_entities/estados';
import { environment } from './../../../../../environments/environment';


@Component({
	selector: 'kt-sin-transmitir',
	templateUrl: './sin-transmitir.component.html',
	styleUrls: ['./sin-transmitir.component.scss']
})
export class SinTransmitirComponent implements OnInit {
	public titulo: string = 'Vehículos Sin Transmitir';
	public listaSinTransmitir: SinTransmitir[];
	public datosReporte = [];
	public busquedaForm: FormGroup;
	public loadingVisible: boolean
	public showFilterRow: boolean;
	public mensajeAgrupar: string = "Arrastre un encabezado de columna aquí para agrupar por esa columna"
	 isDisabled: boolean = true;

	public showHeaderFilter: boolean;

	constructor(private sinTransmitirService: SinTransmitirService,
		private fb: FormBuilder,
		private router: Router,
		private toastService: ToastrService,
		private datepipe: DatePipe) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
	}

	ngOnInit() {
		this.listaSinTransmitir = [];
		this.initForm();
	}

	initForm() {
		this.busquedaForm = this.fb.group({
			cantidadDias: ['']
		})
	}

	obtenerListaSinTransmitir() {
		this.loadingVisible = true;
		this.sinTransmitirService.obtenerSinTransmitir(this.busquedaForm.get('cantidadDias').value).pipe(
			finalize(
				() => {
					this.loadingVisible = false;
					this.busquedaForm.reset();
				}
			)
		).subscribe(
			(sinTransmitir: SinTransmitir[]) => {
				if (sinTransmitir.length === 0) {
					this.toastService.warning('Sin datos existentes');
				}
				sinTransmitir.map(producto => {
					producto.fechaHora = this.datepipe.transform(producto.fechaHora, 'dd/MM/yyyy HH:mm:ss a')

					const estado = ALERTAS.find(alerta => alerta.id == producto.estado);
					producto.estado = estado.nombre;

					if(producto.velocidad !== null){
						producto.velocidad = producto.velocidad + ' Km/h'
					}

				});
				this.listaSinTransmitir = sinTransmitir;
				this.listaSinTransmitir.forEach(producto => {
					let link = `${environment.EXTERNAL_MAP}/ubicar?lat=${producto.lat}&lng=${producto.lng}`
					this.datosReporte.push({
						'Ubicacion': {
							f: '=HYPERLINK("' + link + '","Ubicar")',
							v: link
						},
						'IMEI': producto.imei.toString(),
						'Económico': producto.economico,
						'Placas': producto.placas,
						'Cliente': producto.nombreCliente,
						'Estado': producto.estado,
						'Fecha y Hora': producto.fechaHora,
						'Tiempo sin Transmitir': producto.diasSinTransmitir,
						'Latitud': producto.lat,
						'Longitud': producto.lng,
						'Velocidad': producto.velocidad,
						'Marca': producto.marca,
						'Modelo': producto.modelo
					});
				});
				if(this.datosReporte.length > 0){
					this.isDisabled = false;
				}
			}, (error) => {
				this.toastService.error('Ocurrio un error al obtener datos')
			}
		)
	}

	regresar() {
		this.router.navigateByUrl('/home/administracion/consola/alertados');
	}

}
